export default (decimals: number, n: number): number => Math.round(n * 10 ** decimals) / 10 ** decimals
